import { render, staticRenderFns } from "./bnrSpring.vue?vue&type=template&id=4e7293a0&scoped=true"
import script from "./bnrSpring.vue?vue&type=script&lang=js"
export * from "./bnrSpring.vue?vue&type=script&lang=js"
import style0 from "./bnrSpring.vue?vue&type=style&index=0&id=4e7293a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7293a0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,VImg: require('/var/www/tubber-new/components/global/v/img.vue').default})
